import { useLanguage } from "@/i18n/LanguageContext";

const WhyThisApproachSection = () => {
  const { t } = useLanguage();

  return (
    <section id="why-this-approach" className="py-24 bg-primary text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
            {t("why.title")}
          </h2>

          <div className="space-y-6 text-lg text-white/80 font-serif leading-relaxed">
            <p>{t("why.p1")}</p>
            <p className="text-xl text-white font-medium">
              {t("why.p2a")}
              <br />
              {t("why.p2b")}
            </p>
            <p>{t("why.p3")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyThisApproachSection;
